import React, { useState, useEffect } from 'react';
import { Button, Input, notification, Card, Spin } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ContainerRow, TitleRow } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { getMipsPrompt, updateMipsPrompt } from '../../../Apis/God';

const { TextArea } = Input;

const MipsManagement = () => {
  const [prompt, setPrompt] = useState('');
  const [editedPrompt, setEditedPrompt] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  useEffect(() => {
    setFetchLoading(true);
    getMipsPrompt()
      .then(response => {
        if (response.data.success) {
          setPrompt(response.data.result?.[0] || '');
        }
      })
      .finally(() => setFetchLoading(false));
  }, []);

  const handleEdit = () => {
    setEditedPrompt(prompt);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setEditedPrompt('');
    setIsEditing(false);
  };

  const handleSave = () => {
    setSaveLoading(true);
    updateMipsPrompt(editedPrompt)
      .then(response => {
        if (response.data.success) {
          setPrompt(editedPrompt);
          setIsEditing(false);
          notification.success({
            message: 'Saved',
            description: response.data.message || 'MIPS prompt updated successfully.'
          });
        }
      })
      .finally(() => setSaveLoading(false));
  };

  return (
    <ContainerRow>
      <TitleRow justify='space-between' align='middle'>
        <CustomTypography>MIPS Management</CustomTypography>
        {!isEditing && !fetchLoading && (
          <Button
            type='primary'
            shape='round'
            icon={<EditOutlined />}
            onClick={handleEdit}
          >
            Edit
          </Button>
        )}
      </TitleRow>

      <Card
        title='MIPS Prompt'
        bordered={false}
        style={{ width: '100%', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}
      >
        {fetchLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
            <Spin />
          </div>
        ) : isEditing ? (
          <>
            <TextArea
              value={editedPrompt}
              onChange={e => setEditedPrompt(e.target.value)}
              rows={6}
              style={{ fontSize: 14, borderRadius: 6 }}
              placeholder='Enter MIPS prompt...'
            />
            <div style={{ display: 'flex', gap: 10, marginTop: 16, justifyContent: 'flex-end' }}>
              <Button shape='round' onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                type='primary'
                shape='round'
                loading={saveLoading}
                disabled={!editedPrompt.trim() || editedPrompt === prompt}
                onClick={handleSave}
              >
                Save
              </Button>
            </div>
          </>
        ) : (
          <p style={{ fontSize: 14, lineHeight: 1.7, margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {prompt || 'No MIPS prompt configured yet.'}
          </p>
        )}
      </Card>
    </ContainerRow>
  );
};

export default MipsManagement;
